import React from 'react';
import { cx } from '@emotion/css';
import { Card as MUICard, Divider } from '@mui/material';
import { ix } from '../../../utils/ix';
import { Typography } from '../../electrons';
import { useStyles } from './Card.styles';
export function Card({ active, cardActions, className, children, headline, id, }) {
    const classes = useStyles();
    return (React.createElement(MUICard, { className: cx(className, classes.root, { active }), component: "article", id: id },
        headline && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.headline, id: ix(id, 'card-headline') }, typeof headline === 'string' ? (React.createElement(Typography, { variant: "h5" }, headline)) : (headline)),
            React.createElement(Divider, null))),
        React.createElement("div", { className: classes.content, id: ix(id, 'card-content') }, children),
        cardActions && (React.createElement("footer", { className: classes.cardActions, id: ix(id, 'card-actions') }, cardActions))));
}
//# sourceMappingURL=Card.js.map